module.exports = __webpack_public_path__ + "static/media/featured-video-poster.1fccf508.avif";